import { Flex, Paper, Text } from '@mantine/core'
import React from 'react'

interface Props {
    label: string
    value: string
}

const ConcludeBoxData: React.FC<Props> = ({ label, value }) => {
    return (
        <Paper p='lg' shadow='xs'>
            <Text size='14px' c='text.2' mb='md'>
                {label}
            </Text>
            <Flex justify='flex-end' align='end' gap='10px'>
                <Text fw='bold' size='36px' c='text.2'>
                    {value}
                </Text>
                <Text size='14px' mb='5px' c='text.2'>
                    คน
                </Text>
            </Flex>
        </Paper>
    )
}

export default ConcludeBoxData
